import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getCurrentDate } from "../../../utils/date";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Input from "../../../components/Inputs/Input";
import { useSelector, useDispatch } from "react-redux";
import { fetchBusinesses } from "../../../store/slices/tablesInfoSlices/businessSlice";
import { createCollectionBusiness } from "../../../store/slices/tablesInfoSlices/collectionsSlice";

const validationSchema = Yup.object().shape({});

export default function BusinessNewCollection() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const businessData = useSelector((state) => state.businesses.data);
  const user = useSelector((state) => state.auth.user);
  const collectionInfo = businessData?.find(
    (item) => item.id === parseInt(id, 10)
  );

  const name = collectionInfo?.name;
  const company_name = collectionInfo?.company_name;
  const [collectionValue, setCollectionValue] = useState(null);
  const previousOwe = collectionInfo?.business_balance;
  const [paymentType, setPaymentType] = useState("Komune");

  useEffect(() => {
    dispatch(fetchBusinesses());
  }, [dispatch, id]);

  const calculatedTotal = () => {
    return previousOwe - collectionValue;
  };

  const handlePaymentType = () => {
    if (collectionValue > 10) {
      return setPaymentType("Banke");
    } else {
      return setPaymentType("Komune");
    }
  };

  useEffect(() => {
    calculatedTotal();
    handlePaymentType();
  }, [collectionValue]);

  const handleSubmit = (values) => {
    dispatch(createCollectionBusiness(values));
    navigate("/business")
  };

  return (
    <div className="p-6">
      <h1 className="py-6 text-blue-900 font-semibold">Shto inkasim</h1>
      <Formik
        initialValues={{
          business_id: collectionInfo?.id || "",
          value: collectionValue || "",
          type: paymentType || "",
          user_id: user?.id || "",
          tipifat: "Tipifat",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnBlur
        enableReinitialize
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form className="space-y-4 text-xs">
            <Input
              label="Emri"
              id="name"
              name="name"
              placeholder="Emri"
              value={name}
              disabled={true}
            />
            <Input
              label="Emri i kompanise"
              id="surname"
              name="surname"
              value={company_name}
              placeholder="Emri i kompanise"
              error={errors.surname && touched.surname ? errors.surname : null}
              disabled
            />
            <Input
              label="Vlera"
              id="value"
              name="value"
              type="number"
              placeholder="Vlera"
              value={collectionValue}
              onChange={(e) => setCollectionValue(parseFloat(e.target.value))}
              error={
                errors.collectionValue && touched.collectionValue
                  ? errors.collectionValue
                  : null
              }
            />
            <Input
              label="Data"
              id="data"
              name="data"
              value={getCurrentDate()}
              placeholder="dd/mm/yyyy"
              disabled
            />
            <Field
              name="paymentType"
              render={({ field }) => (
                <Input
                  label="Tipi"
                  id="type"
                  name="type"
                  value={paymentType}
                  placeholder="Tipi"
                  disabled
                />
              )}
            />
            <Input
              label="Borgji Paraprak"
              id="previousOwe"
              name="previousOwe"
              placeholder="Borgji Paraprak"
              value={previousOwe}
              disabled
            />
            <Input
              label="Totali"
              id="totali"
              name="totali"
              value={calculatedTotal() || "0"}
              placeholder="Shuma Totale"
              disabled
            />
            <div className="flex justify-end">
              <Link to="/collection">
                <button
                  type="button"
                  className="px-4 py-2 mr-2 bg-white text-[#28ABE2] rounded-md"
                >
                  Anulo
                </button>
              </Link>
              <button
                type="submit"
                className="px-12 py-2 bg-[#2FBFDE] text-white rounded-md"
              >
                Ruaj
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
